import style from './Article.module.css';
import Cards from './Cards'

const Article =()=>{

    return <section className={style.articleSection}>
        <h2 className={style.title}>Latest Articles</h2>
        <Cards></Cards>
    </section>

}

export default Article;